var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 48,
    viewBox: "0 0 107 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0H83C96.2548 0 107 10.7452 107 24C107 37.2548 96.2548 48 83 48H24C10.7452 48 0 37.2548 0 24Z",
    fill: "#E95BBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0H83C96.2548 0 107 10.7452 107 24C107 37.2548 96.2548 48 83 48H24C10.7452 48 0 37.2548 0 24Z",
    fill: "black",
    fillOpacity: 0.07
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2578 12.8348L34.8662 25.6434V12.5848H40.0303V35.0907H35.209L26.4316 22.0311V35.0907H21.2676V12.5848H26.0889L26.2578 12.8348ZM59.208 17.3065H49.3018V21.1649H58.7139V25.8866H49.3018V30.368H59.4678V35.0907H44.0859V12.5848H59.208V17.3065ZM78.8018 13.0184L82.1279 26.7469L85.5 13.0165L85.6055 12.5848H90.9131L85.2178 35.0907H79.3926L76.1699 22.0409L72.9482 35.0907H67.123L61.4277 12.5848H66.7354L66.8408 13.0165L70.2119 26.7499L73.6436 12.6132L78.6953 12.5819L78.8018 13.0184ZM70.2158 29.1415V29.1385L66.29 13.1512L70.2158 29.1415Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBadge);
export default __webpack_public_path__ + "static/media/new_badge.f97ab7a72c14db34a8382f05b88bf089.svg";
export { ForwardRef as ReactComponent };